// eslint-disable-next-line @typescript-eslint/no-explicit-any
const promiseCtor = Promise as any;

if (!promiseCtor.withResolvers) {
  promiseCtor.withResolvers = function <T>() {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve: resolve!, reject: reject! };
  };
}
